import React, { useLayoutEffect, useState } from 'react';
import ReactDOM from 'react-dom';

interface PortalDropdownProps {
  anchorRef: React.RefObject<HTMLElement>;
  children: React.ReactNode;
}

const PortalDropdown: React.FC<PortalDropdownProps> = ({ anchorRef, children }) => {
  const [style, setStyle] = useState<React.CSSProperties>({});

  useLayoutEffect(() => {
    const updatePosition = () => {
      const rect = anchorRef.current?.getBoundingClientRect();
      if (!rect) return;
      setStyle({
        position: 'fixed',
        top: rect.bottom,
        left: rect.left,
        width: rect.width,
        zIndex: 9999,
      });
    };

    updatePosition();
    window.addEventListener('scroll', updatePosition, true);
    window.addEventListener('resize', updatePosition);

    return () => {
      window.removeEventListener('scroll', updatePosition, true);
      window.removeEventListener('resize', updatePosition);
    };
  }, [anchorRef]);

  return ReactDOM.createPortal(
    <div className="dropdown-list-portal" style={style}>
      {children}
    </div>,
    document.body
  );
};

export default PortalDropdown;